import React from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@culturehq/components";

import { useProfile } from "app/context";
import useUnseen from "app/context/useUnseen";
import { Trans } from "app/utils";

import { useFeedRoute } from "components/Home";

const FeedNavItem = () => {
  const { profile } = useProfile();
  const [feedRoute, isFeedRouteActive] = useFeedRoute(profile);
  const unseen = useUnseen(feedRoute);

  return (
    <li>
      <NavLink
        exact
        to={feedRoute}
        onClick={() => window.scrollTo(0, 0)}
        isActive={(match, location) => isFeedRouteActive(match, location) || location.pathname === "/"}
        className="chq-nav--feed"
      >
        <Icon icon="home" />
        <Trans> Home</Trans>
        {unseen.unseenHome && <div className="chq-nav--unseen" />}
      </NavLink>
    </li>
  );
};

export default FeedNavItem;
